import { FormValidationRule } from "../types";

const validTime: FormValidationRule = (control, value) => {
    let valid = true;

    if (value && control && control.type === "time") {
        Object.values(value).every(
            element =>
                element === null || element === undefined || element === ""
        ) && !control.isRequired
            ? (valid = true)
            : (valid = false);
        if (
            Object.values(value).every(
                element =>
                    element !== null && element !== undefined && element !== ""
            )
        )
            valid = true;
    }

    return [valid, ""];
};

export default validTime;
